/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { SlaSummary } from './sla-summary';
import { CaseRef } from './case-ref';
import { CustomerCompanyRef } from './customer-company-ref';
import { ActorRef } from './actor-ref';
import { CustomerContactRef } from './customer-contact-ref';
import { EcusUserRef } from './ecus-user-ref';
import { DepartmentRef } from './department-ref';
import { ClearanceCaseStatus } from '../enums/clearance-case-status.enum';
import { ClearanceCaseCustomerStatus } from '../enums/clearance-case-customer-status.enum';
import { ImportExportCountry } from '../enums/import-export-country.enum';
import { TransportType } from '../enums/transport-type.enum';
import { CaseDocumentType } from '../enums/case-document-type.enum';
import { InvoicingStatus } from '../financials/enums/invoicing-status.enum';
import { SwedishTaxPayerType } from '../enums/swedish-tax-payer-type.enum';

//<custom-head>
import { parseDate } from 'app/utils';
import { format, isBefore, isToday, isTomorrow } from 'date-fns';
import { environment } from 'environments/environment';
import { fromZonedTime } from 'date-fns-tz';
//</custom-head>

export class ClearanceCaseSummaryDto extends SlaSummary {
  public id: string = undefined;
  public ecomId: string = undefined;
  public caseDocumentId: string = undefined;
  public registrationId: string = undefined;
  public mainCase: CaseRef;
  public company: CustomerCompanyRef;
  public sender: string = undefined;
  public receiver: string = undefined;
  public invoiceRecipients: ActorRef[];
  public contact: CustomerContactRef;
  public caseManager: EcusUserRef;
  public department: DepartmentRef;
  public deliveryConditionCode: string = undefined;
  public status: ClearanceCaseStatus;
  public seStatus: ClearanceCaseStatus;
  public noStatus: ClearanceCaseStatus;
  public customerStatus: ClearanceCaseCustomerStatus;
  public exportCountry: ImportExportCountry;
  public exportDeclarationCode: string = undefined;
  public importCountry: ImportExportCountry;
  public importDeclarationCode: string = undefined;
  public transportType: TransportType;
  public transportIdentityArrival: string = undefined;
  public hasUnreadMessages: boolean;
  public hasAnyMessages: boolean;
  public isCancelled: boolean;
  public isClearanceCase: boolean;
  public isCaseDocument: boolean;
  public isRegistration: boolean;
  public createdDate: Date | string;
  public reference: string = undefined;
  public containerNumbers: string[];
  public caseDocumentTypes: CaseDocumentType[];
  public houseAirWaybill: string = undefined;
  public masterAirWaybill: string = undefined;
  public customsId: string = undefined;
  public sequenceNumber: string = undefined;
  public carRegistrationNumber: string = undefined;
  public mrn: string = undefined;
  public invoiceNumber: string = undefined;
  public lineNumber: string = undefined;
  public grossWeight: number = undefined;
  public invoicingStatus: InvoicingStatus;
  public swedishTaxPayerType: SwedishTaxPayerType;

  //<custom-body>
  public get hasSlaTime(): boolean {
    return !!this.slaStartDate;
  }

  public get slaStartDateFormatted(): string {
    const date = parseDate(this.slaStartDate);

    if (isToday(date)) return format(date, "'idag,' HH:mm");
    else if (isTomorrow(date)) return format(date, "'imorgon,' HH:mm");

    return format(date, environment.defaultDateMoment);
  }

  public get slaExpired(): boolean {
    return (
      this.status !== ClearanceCaseStatus.Completed &&
      this.status !== ClearanceCaseStatus.Cancelled &&
      isBefore(
        parseDate(this.slaStartDate),
        fromZonedTime(new Date(), environment.timezone)
      )
    );
  }
  //</custom-body>
}
